import { GET_PRESET_LIST_KEY } from '@src/api/emp/queryHooks';
import { DIMENSION_LIST } from '@src/emp-3.0/utils/constants';
import { queryClient } from '@src/routers/constants';

import { putUpdatePreset } from '../api/query';

export const updatePreset = async (id: number, newPreset: any) => {
  if (newPreset.dimensionFixed) return;
  const newDimensions = (newPreset?.dimensions ?? []).map((dimension) => dimension.dimensionName);
  if (id) {
    await putUpdatePreset(id, {
      preset_name: 'Explore',
      dimensions: newDimensions,
    })
      .then(() => {
        queryClient.invalidateQueries([GET_PRESET_LIST_KEY]);
      })
      .catch((error) => {
        console.log('%c update preset: ', 'color: #DC362E', error?.response?.data?.msg);
      });
  }
};
